import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Util from './../Util/Util'
import { ListItemIcon } from '@material-ui/core';

class AbacusSelect extends React.Component {
  isMobile = false;
  constructor(props) {
    super(props);
    let util = new Util();
    this.isMobile = util.isMobileDevice();
  }

  handleChange = event => {
    if(this.props.onChange !== undefined){
      this.props.onChange(event);
    }
  };

  createSelectItems() {
    let items = [];         
    this.props.list.forEach(element => {
      if(this.isMobile){
        items.push(<option key={element.value} value={element.value}>{element.text}</option>);
      }
      else
      {
        if(element.icon===undefined)
        items.push(<MenuItem key={element.value} value={element.value}>{element.text}</MenuItem>);
        else
        items.push(<MenuItem key={element.value} value={element.value}><ListItemIcon>{element.icon}</ListItemIcon>{element.text}</MenuItem>);
       // items.push(<MenuItem key={element.value} value={element.value}>{element.text}</MenuItem>);
      }
    });
    
    return items;
  }  

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.label === this.props.label && nextProps.list === this.props.list && nextProps.value === this.props.value && nextProps.error === this.props.error && nextProps.errorText === this.props.errorText && nextProps.disabled === this.props.disabled){
      return false;
    }
    return true;
  }
  
  render() {
    let value = this.props.value;
    if(value === undefined){
      value = "";
    }

    // For mobile control use select native to get mobile ui select control.
    if(!this.isMobile){
      return (
        <FormControl style={this.props.style} error={this.props.error}>
          <InputLabel htmlFor="helper">{this.props.label}</InputLabel>
          <Select
            disabled={this.props.disabled}
            value={value}
            onChange={this.handleChange}
            input={<Input name="name" id="helper" />}>
            
            {this.createSelectItems()}
          </Select>
          <FormHelperText>{this.props.error?this.props.errorText:this.props.helperText}</FormHelperText>
        </FormControl>
      );
    }
    else
    {
      return (
        <FormControl style={this.props.style} error={this.props.error}>
          <InputLabel htmlFor="helper">{this.props.label}</InputLabel>
          <Select
            native
            value={value}
            onChange={this.handleChange}
            input={<Input name="name" id="helper" />}
          >
            {this.createSelectItems()}
          </Select>
          <FormHelperText>{this.props.error?this.props.errorText:this.props.helperText}</FormHelperText>
        </FormControl>
      );
    }
  }
}

  export default AbacusSelect;